import { colors } from "@material-ui/core";

export enum MemberStatus {
  approved = "approved",
  declined = "declined",
  pending = "pending",
  locked = "locked",
  new = "new",
  all = "all",
}

export function memberStatusColor(status: MemberStatus, degradation: number) {
  switch (status) {
    case MemberStatus.approved:
      return colors.green[degradation];
    case MemberStatus.pending:
      return colors.orange[degradation];
    case MemberStatus.new:
      return colors.blue[degradation];
    case MemberStatus.locked:
      return colors.red[degradation];
    case MemberStatus.declined:
      return colors.pink[degradation];
  }
}
